import { AxiosResponse } from 'axios';
import { History } from 'history';
import { updateItem } from 'react-use-cookie';
import { AnyAction, Dispatch } from 'redux';
import { ChangePasswordPageState } from '../../interfaces/ChangePasswordPageState';
import { redirectTo } from '../../../../utils/redirectTo';
import { onError } from './onError';
import Configuration from '../../../../utils/Configuration';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function onSuccessPassword(
  response: AxiosResponse<any>,
  dispatch: Dispatch<AnyAction>,
  history: History,
  setUserNameCookie: updateItem,
  setRules: (rules: ChangePasswordPageState) => void,
  rules: ChangePasswordPageState,
) {
  if (response.status === 200) {
    const config = Configuration.Current();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    setUserNameCookie(response.data.username as string, { path: '/', days: 1 });
    document.cookie = 'oktaStateToken=; expires=Thu, 18 Dec 2013 12:00:00 UTC; path=/';
    if (config.isOktaHosting) {
      document.location.hash = '#/change-password-confirm';
    } else {
      redirectTo('/change-password-confirm', history);
    }
  } else {
    onError(response.data as any[], dispatch, setRules, rules);
  }
}
